import { render, staticRenderFns } from "./ClubMascot.vue?vue&type=template&id=7c13eab4"
import script from "./ClubMascot.vue?vue&type=script&lang=js"
export * from "./ClubMascot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports